import { isMac } from '@/utils/browser'

export const getShortcutWithCmdOrCtrl = (letter) => {
  return isMac() ? `⌘${letter}` : `Ctrl+${letter}`
}

export const shouldShowDirectoryShortcuts = (navigatorLike = globalThis.navigator) => {
  const platform = navigatorLike?.userAgentData?.platform || navigatorLike?.platform || ''
  const userAgent = navigatorLike?.userAgent || ''
  const isIPadOrMobile =
    navigatorLike?.userAgentData?.mobile ||
    /android|ipad|iphone|ipod/i.test(userAgent) ||
    (/mac/i.test(platform) && navigatorLike?.maxTouchPoints > 1)

  // ponytail: revisit when browser Keyboard API exposes physical keyboard presence.
  if (isIPadOrMobile) return false
  return /mac|win|linux|chrome os|cros/i.test(platform)
}
